module.exports = __webpack_public_path__ + "static/thumbnail-7b536ec8eb4e6085ec4e38a1fd349950.png";